"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = HomePage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var message_1 = require("../components/dialogs/message");
var content_dialog_1 = require("../features/thunks/content-dialog");
var message_dialog_1 = require("../features/thunks/message-dialog");
var hooks_1 = require("../store/hooks");
function HomePage() {
    var dispatch = (0, hooks_1.useAppDispatch)();
    var items = [
        {
            key: "new",
            label: "New file",
        },
        {
            key: "copy",
            label: "Copy link",
        },
        {
            key: "edit",
            label: "Edit file",
        },
        {
            key: "delete",
            label: "Delete file",
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { className: "bg-blue-500 text-white", onPress: function () {
                    alert("Button tested!");
                }, children: "Alert" }), (0, jsx_runtime_1.jsxs)(react_1.Dropdown, { isDisabled: false, disableAnimation: true, showArrow: true, children: [(0, jsx_runtime_1.jsx)(react_1.DropdownTrigger, { children: (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", children: "Open Dropdown" }) }), (0, jsx_runtime_1.jsx)(react_1.DropdownMenu, { "aria-label": "Dynamic Actions", items: items, selectionMode: "single", onSelectionChange: function (keys) { return console.log("Selected ".concat(keys.currentKey)); }, children: function (item) { return ((0, jsx_runtime_1.jsx)(react_1.DropdownItem, { className: item.key === "delete" ? "text-danger" : "", color: item.key === "delete" ? "danger" : "default", children: item.label }, item.key)); } })] }), (0, jsx_runtime_1.jsx)(react_1.Button, { className: "bg-orange-500 text-white", onPress: function () {
                    (0, react_1.addToast)({
                        title: "This is a toast notification",
                        description: "Hello! This is a sample toast message to demonstrate the ToastProvider functionality.",
                        timeout: 5000,
                        color: "success",
                        shouldShowTimeoutProgress: true,
                    });
                }, children: "Show a Toast" }), (0, jsx_runtime_1.jsx)(react_1.Button, { className: "bg-red-500 text-white", onPress: function () {
                    dispatch((0, content_dialog_1.showContentDialogThunk)({
                        header: "Welcome to the Content Dialog",
                        content: (0, jsx_runtime_1.jsx)("div", { className: "p-4", children: "Content goes here" }),
                    }));
                }, children: "Content Dialog" }), (0, jsx_runtime_1.jsx)(react_1.Button, { className: "bg-green-500 text-white", onPress: function () {
                    dispatch((0, message_dialog_1.showMessageDialogThunk)({
                        header: "Welcome to the Message Dialog",
                        body: "This is a message dialog example.",
                        buttons: [
                            {
                                label: "OK",
                                variant: "solid",
                                type: message_1.EMessageDialogButtonType.OK,
                                onClick: function () {
                                    console.log("OK clicked");
                                },
                            },
                        ],
                    }));
                }, children: "Message Dialog" }), (0, jsx_runtime_1.jsx)(react_1.Checkbox, { defaultSelected: true, children: "Checkbox Example" })] }));
}
